import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios-https-proxy-fix";
import UploadPreview from "../../../components/UploadPreview/UploadPreview.js";
import ColourPreview from "../../../components/ColourPreview/ColourPreview.js";
import EditorComponent from "../../../components/EditorComponent/EditorComponent.js";
import { Dropdown, Input } from "semantic-ui-react";
import "./PictureBookCustomerSettings.scss";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import translator from "../../../utils/translator";

export class PictureBookCustomerSettings extends Component {
	// ========== STATE ==========
	resetSettings = () => {
		return {
			loaded: 0,

			// Table
			show_home_owner_homepage: 0,
			show_account_owner_homepage: 0,
			show_spec_links: 0,
			show_project_name: 0,
			show_home_owner_contact: 0,
			include_notes: 0,
			show_pricing: 0,
			show_vendor: 0,
			show_model_number: 0,
			show_sku_number: 0,
			show_product_quantity: 0,
			show_summary: 0,
			show_standard_pricing: 0,
			show_website: 0,
			picturebook_footer_show_page: 0,

			// Colours
			use_picturebook_colours: 0,
			colour: "#000000",
			price_colour: "#000000",

			// Existing images
			full_cover_url: "",
			full_header_url: "",
			full_footer_url: "",

			// Uploads
			picturebook_cover: "",
			picturebook_header: "",
			picturebook_footer: "",
			"delete-cover": 0,
			"delete-header": 0,
			"delete-footer": 0,

			// Footer
			picturebook_footer_text: "",
			picturebook_footer_text_show_last_page: 0
		};
	};

	state = {
		allAccounts: {},
		searchTimeout: null,
		accountQuery: "",
		account: "",
		allShipTos: {},
		shipto: "",
		warehouse: "",
		response: {},
		settings: this.resetSettings()
	};

	// ========== UTILS ==========

	nestedCopy = (oldObject, newValue, ...keys) => {
		// returns a copy of the object, where the newValues is updated at the index of the nested keys (i.e. [key1][key2][key3]...)
		return keys
			.reduce((copies, key) => copies.concat(copies[copies.length - 1][key]), [oldObject])
			.slice(0, -1)
			.reduceRight((newObject, prevCopy, index) => ({ ...prevCopy, [keys[index]]: newObject }), newValue);
	};

	updateNestedState = (...keys) => {
		// updates state with newValue (last key) at index of the nested keys (i.e. [key1][key2][key3]...)
		let newValue = keys.pop();
		this.setState(state => {
			return this.nestedCopy(state, newValue, ...keys);
		});
	};

	toggleNestedState = (...keys) => {
		// toggles value between 0 & 1 at index of the nested keys (i.e. [key1][key2][key3]...)
		this.setState(state => {
			return this.nestedCopy(state, keys.reduce((obj, key) => obj[key], state) ? 0 : 1, ...keys);
		});
	};

	arrayToObject = (arr, key) => arr.reduce((obj, item) => ({ ...obj, [item[key]]: item }), {});

	// ============= AJAX FUNCTIONS =============

	callAjax = async (route, data) => {
		data.trendId = localStorage.getItem("trendId");
		data.token = localStorage.getItem("token");

		let APIResponse = await Axios.post(this.props.APIUrl + route, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.setState({ response: { error: APIResponse.data.error } });
			return false;
		}
		this.setState({ response: {} });
		return APIResponse.data;
	};

	getAccounts = async query => {
		this.setState({ response: { loadingbar: translator("Misc", "loading_label") } });
		let route = "/emco_settings/search-accounts";
		let response = await this.callAjax(route, { q: query });
		if (!response) return;
		if (!response.hasOwnProperty("data")) this.setState({ allAccounts: {} });
		else this.setState({ allAccounts: this.arrayToObject(response.data, "CustomerNumber") });
	};

	getShipTos = async (account, warehouse) => {
		this.setState({ response: { loadingbar: translator("Misc", "loading_label") } });
		let route = "/emco_settings/search-shiptos";
		let response = await this.callAjax(route, { account_id: account, warehouse });
		if (!response) return;
		if (!response.hasOwnProperty("data")) this.setState({ allShipTos: {} });
		else this.setState({ allShipTos: this.arrayToObject(response.data, "ShipTo") });
	};

	getSettings = async (account, shipto, warehouse) => {
		this.setState(state => ({ response: { loadingbar: translator("Misc", "loading_label") }, settings: { ...state.settings, loaded: 0 } }));

		let route = "/emco_settings/get-customer-picturebook-settings";
		let response = await this.callAjax(route, { account: account, shipTo: shipto, warehouse: warehouse });
		if (!response) return;

		let settings = this.resetSettings();
		settings.loaded = 1;

		Object.keys(settings).forEach(key => {
			if (response.settings.hasOwnProperty(key) && response.settings[key]) settings[key] = response.settings[key];
		});
		settings.picturebook_cover = "";
		settings.picturebook_header = "";
		settings.picturebook_footer = "";

		if (settings.colour) response.settings.use_picturebook_colours = 1;

		this.setState({ settings: settings });
	};

	saveSettings = async (account, shipto, warehouse, settings) => {
		this.setState({ response: { loadingbar: translator("Misc", "loading_label") } });
		let route = "/emco_settings/save-customer-picturebook-settings";
		let data = {
			"account-id": account,
			"ship-to": shipto,
			warehouse: warehouse
		};
		data = { ...data, ...settings };
		let response = await this.callAjax(route, data);
		if (!response) return;

		let newRoute = "/emco_settings/get-customer-picturebook-settings";
		let newResponse = await this.callAjax(newRoute, { account: account, shipTo: shipto, warehouse: warehouse });
		if (!newResponse) return;

		this.setState(state => ({
			// Set response
			response: response,
			settings: {
				...state.settings,
				// Get new images
				full_cover_url: newResponse.settings.full_cover_url,
				full_header_url: newResponse.settings.full_header_url,
				full_footer_url: newResponse.settings.full_footer_url,
				// Reset Uploaders
				picturebook_cover: "",
				picturebook_header: "",
				picturebook_footer: "",
				"delete-cover": 0,
				"delete-header": 0,
				"delete-footer": 0
			}
		}));
	};

	// ============= HANDLER FUNCTIONS =============

	setImage = (key, img) => {
		this.updateNestedState("settings", key, img);
	};

	setColour = (key, colour) => {
		this.updateNestedState("settings", key, colour);
	};

	setHTML = text => {
		this.updateNestedState("settings", "picturebook_footer_text", text);
	};

	searchAccounts = query => {
		window.clearTimeout(this.state.searchTimeout);
		this.setState({
			searchTimeout: window.setTimeout(this.getAccounts, 500, query)
		});
	};

	setAccount = account => {
		this.setState({ account: account, allShipTos: {}, shipto: "", warehouse: "" });
		this.getShipTos(account, this.state.warehouse);
	};

	// ============= RENDER FUNCTIONS =============

	renderAccount = state => {
		let accountOptions = Object.entries(state.allAccounts).map(account => ({ value: account[0], text: account[1].Name + ' | ' + account[1].CustomerNumber }));
		let shiptoOptions = Object.entries(state.allShipTos).map(shipto => ({
			value: shipto[0],
			text: (
				<div class="dropdown-shipto">
					<span class="dropdown-shipto-shipto">{shipto[1].ShipTo}</span>
					<span class="dropdown-shipto-name">{shipto[1].Name}</span>
					<span class="dropdown-shipto-address1">{shipto[1].Address1}</span>
					<span class="dropdown-shipto-address2">{shipto[1].Address2}</span>
				</div>
			)
		}));
		shiptoOptions.unshift({
			value: "",
			text: (
				<div class="dropdown-shipto">
					<span class="dropdown-shipto-shipto">{translator("Admin Pricing", "none_label")}</span>
				</div>
			)
		});
		return (
			<div class="card user-profile-card mb1">
				<div class="card-body">
					<div className="account-input-line">
						<label>{translator("Misc", "account_label")}</label>
						<Dropdown
							fluid
							search={(options, query) => options}
							selection
							placeholder={translator("Admin Picturebook", "account_placeholder")}
							options={accountOptions}
							onSearchChange={(e, d) => {
								this.searchAccounts(d.searchQuery);
							}}
							onChange={(e, d) => this.setAccount(d.value)}
						/>
					</div>
					{state.account ? (
						<div className="account-input-line">
							<label>{translator("Admin Picturebook", "ship_to_label")}</label>
							<Dropdown fluid selection options={shiptoOptions} onChange={(e, d) => this.setState({ shipto: d.value })} />
						</div>
					) : null}
					{state.account ? (
						<div className="account-input-line">
							<label>{translator("Admin Picturebook", "warehouse_label")}</label>
							<Input className={"fullwidth"} value={state.warehouse} onChange={(e, d) => this.setState({ warehouse: d.value })} />
						</div>
					) : null}
					{state.account && state.warehouse ? (
						<button type="button" class="btn btn-primary account-submit" onClick={e => this.getSettings(state.account, state.shipto, state.warehouse)}>
							{translator("Admin Picturebook", "find_info_label")}
						</button>
					) : null}
				</div>
			</div>
		);
	};

	renderTable = settings => {
		let titles = {
			show_home_owner_homepage: "show_home_owner_homepage_label",
			show_account_owner_homepage: "show_account_owner_label",
			show_spec_links: "show_spec_links",
			show_project_name: "show_project_name_label",
			show_home_owner_contact: "show_home_owner_contact_label",
			include_notes: "include_notes_label",
			show_pricing: "show_pricing_label",
			show_vendor: "show_vendor_name_label",
			show_model_number: "show_model_number_label",
			show_sku_number: "show_sku_number",
			show_product_quantity: "show_product_quantity",
			show_summary: "show_summary",
			show_standard_pricing: "show_standard_pricing",
			show_website: "show_website",
			picturebook_footer_show_page: "picturebook_footer_page_show_label"
		};
		return (
			<table class="table table-bordered search-results-table checkbox-table">
				<tbody>
					{Object.entries(titles).map(title => {
						return (
							<tr key={title[0]}>
								<td>
									<h3 class="application-settings-sub-header">{translator("Admin Picturebook", title[1])}</h3>
								</td>
								<td class="settings-checkbox-td">
									<input type="checkbox" class="dn" id={title[0]} checked={settings[title[0]]} onChange={() => this.toggleNestedState("settings", title[0])} />
									<label class="settings-label" htmlFor={title[0]}>
										<div class="settings-label-icon">&#10003;</div>
									</label>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	};

	renderColours = settings => {
		return (
			<table class="table table-bordered search-results-table checkbox-table">
				<tbody>
					<tr>
						<td>
							<h3 class="application-settings-sub-header">{translator("Admin Picturebook", "custom_picturebook_colours")}</h3>
						</td>
						<td class="settings-checkbox-td">
							<input type="checkbox" class="dn" id="use_picturebook_colours" checked={settings.use_picturebook_colours} onChange={() => this.toggleNestedState("settings", "use_picturebook_colours")} />
							<label class="settings-label" htmlFor="use_picturebook_colours">
								<div class="settings-label-icon">&#10003;</div>
							</label>
						</td>
					</tr>
					{settings.use_picturebook_colours ? (
						<React.Fragment>
							<tr>
								<td>
									<h3 class="application-settings-sub-header">{translator("Admin Picturebook", "colour_band_label")}</h3>
								</td>
								<td class="settings-checkbox-td">
									<ColourPreview stateKey={"colour"} color={{ hex: settings.colour }} saveColour={this.setColour} />
								</td>
							</tr>
							<tr>
								<td>
									<h3 class="application-settings-sub-header">{translator("Admin Picturebook", "colour_price_label")}</h3>
								</td>
								<td class="settings-checkbox-td">
									<ColourPreview stateKey={"price_colour"} color={{ hex: settings.price_colour }} saveColour={this.setColour} />
								</td>
							</tr>
						</React.Fragment>
					) : null}
				</tbody>
			</table>
		);
	};

	renderUploads = settings => {
		let sections = {
			cover: {
				title: translator("Admin Picturebook", "picturebook_image_label"),
				subtitle: translator("Admin Picturebook", "picturebook_update_message"),
				key: "picturebook_cover",
				delete: "delete-cover",
				image: settings.full_cover_url
			},
			header: {
				title: translator("Admin Picturebook", "picturebook_image_label"),
				subtitle: translator("Admin Picturebook", "picturebook_header_update_message"),
				key: "picturebook_header",
				delete: "delete-header",
				image: settings.full_header_url
			},
			footer: {
				title: translator("Admin Picturebook", "picturebook_footer_image_label"),
				subtitle: translator("Admin Picturebook", "picturebook_footer_update_message"),
				key: "picturebook_footer",
				delete: "delete-footer",
				image: settings.full_footer_url
			}
		};
		return Object.values(sections).map(upload => {
			return (
				<div class="pbook-settings-upload-section" key={upload.key}>
					<div class="form-group mt2">
						<h2 style={{ color: "#16448e" }}>{upload.title}:</h2>
						<p>
							<em>{upload.subtitle}</em>
						</p>
					</div>
					<UploadPreview preview={upload.image} saveImage={this.setImage} stateKey={upload.key} />

					<div class="custom-checkbox-wrapper">
						<input type="checkbox" class="dn" id={upload.delete} checked={settings[upload.delete]} onChange={() => this.toggleNestedState("settings", upload.delete)} />
						<label class="custom-checkbox-label" htmlFor={upload.delete}>
							<div class="label-box"></div>
							<div class="label-message">{translator("Misc", "delete_label")}</div>
						</label>
					</div>
				</div>
			);
		});
	};

	renderFooter = settings => {
		return (
			<div class="pbook-settings-upload-section">
				<div class="form-group mt2">
					<h2 style={{ color: "#16448e" }}>{translator("Admin Picturebook", "picturebook_footer_text_label")}:</h2>
				</div>

				{settings.loaded ? <EditorComponent loadedText={settings.picturebook_footer_text} saveHTML={this.setHTML} /> : null}

				<div class="custom-checkbox-wrapper">
					<input type="checkbox" class="dn" id="show_footer_text_last_page" checked={settings.picturebook_footer_text_show_last_page} onChange={() => this.toggleNestedState("settings", "picturebook_footer_text_show_last_page")} />
					<label class="custom-checkbox-label" htmlFor="show_footer_text_last_page">
						<div class="label-box"></div>
						<div class="label-message">{translator("Admin Picturebook", "picturebook_footer_text_show_label")}</div>
					</label>
				</div>
			</div>
		);
	};

	renderSettings = state => {
		let settings = state.settings;
		return (
			<div class="card user-profile-card">
				<div class="card-body">
					{this.renderTable(settings)}
					{this.renderColours(settings)}
					{this.renderUploads(settings)}
					{this.renderFooter(settings)}

					<button type="button" class="btn btn-primary pbook-settings-submit" onClick={() => this.saveSettings(state.account, state.shipto, state.warehouse, state.settings)}>
						{translator("Admin Picturebook", "submit_btn")}
					</button>
				</div>
			</div>
		);
	};

	renderResponse = response => {
		if (Object.keys(response).length === 0) return null;
		let key = "error";
		if (response.hasOwnProperty("success")) key = "success";
		if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
		let cardClass = "card user-profile-card response-" + key;
		return (
			<div className={cardClass}>
				<div class="card-body">{response[key]}</div>
			</div>
		);
	};

	render() {
		let state = this.state;
		let main = (
			<>
				{this.renderAccount(state)}
				{state.settings.loaded ? this.renderSettings(state) : null}
				{Object.keys(state.response).length ? this.renderResponse(state.response) : null}
			</>
		);
		return (
			<SettingsWrapper header={translator("Admin Picturebook", "page_title")} main={main} classes="picturebook-customer-settings"/>
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PictureBookCustomerSettings);
